import React, { useState } from "react";

import {
	FrontendCompanySampleMatrix,
	FrontendCompanyTestCategory,
	FrontendCompanyWithAdditionalInfomation,
	FrontendSampleSpecification,
	FrontendSampleSpecificationDirectory,
	FrontendUserInfo,
} from "node-library/dist/portal";

import UploadSpecificationDrawer from "../../../../common-components/drawers/uploadSpecificationDrawer";
import SpecificationFilesAndFoldersContents from "./specificationFilesAndFoldersContents";
import CreateSpecificationDrawer from "../../../../common-components/drawers/createSpecificationAndReadingDrawer";
import CreateSpecificationAndReadingDrawer from "../../../../common-components/drawers/createSpecificationAndReadingDrawer";
import CreateOrUpdateSpecificationReadingDrawer from "../../../../common-components/drawers/createOrUpdateSpecificationReadingDrawer";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	setCompany: React.Dispatch<
		React.SetStateAction<FrontendCompanyWithAdditionalInfomation | undefined>
	>;
	user: FrontendUserInfo;
	orgDetailsSelectedCategory: FrontendCompanyTestCategory;

	organizationId: string;
	orgSpecifications: Array<FrontendSampleSpecification>;
	setOrgSpecifications: React.Dispatch<
		React.SetStateAction<Array<FrontendSampleSpecification>>
	>;
	specDirectories: Array<FrontendSampleSpecificationDirectory>;
	setSpecDirectories: React.Dispatch<
		React.SetStateAction<Array<FrontendSampleSpecificationDirectory>>
	>;

	selectedMatrix: FrontendCompanySampleMatrix;

	currentFolder: FrontendSampleSpecificationDirectory | undefined;
	setCurrentFolder: React.Dispatch<
		React.SetStateAction<FrontendSampleSpecificationDirectory | undefined>
	>;
}

export default function SpecificationFilesAndFoldersSection(props: Props) {
	const {
		company,
		setCompany,
		user,
		orgDetailsSelectedCategory,
		orgSpecifications,
		setOrgSpecifications,
		specDirectories,
		setSpecDirectories,
		selectedMatrix,
		currentFolder,
		setCurrentFolder,
		organizationId,
	} = props;

	const [createSpecModalOpen, setCreateSpecModalOpen] =
		useState<boolean>(false);

	const [editSpecReadingDrawerOpen, setEditSpecReadingDrawerOpen] =
		useState<boolean>(false);
	const [selectedSpecFile, setSelectedSpecFile] = useState<
		FrontendSampleSpecification | undefined
	>();

	const matrixId: string = selectedMatrix.matrixId;

	const currentFolderSpecs = matrixId
		? props.orgSpecifications.filter((spec) => {
				// Define the target ID: the directory's ID if it exists, otherwise null
				const targetId = currentFolder ? currentFolder.directoryId : null;

				return (
					spec.matrixId === matrixId &&
					// Matches if spec.parentDirectoryId is the targetId,
					// OR if both are "falsy" (null/undefined)
					(spec.parentDirectoryId === targetId ||
						(!spec.parentDirectoryId && !targetId))
				);
			})
		: [];
	function openSpecReadingDrawer(specFile: FrontendSampleSpecification) {
		setSelectedSpecFile(specFile);
		setEditSpecReadingDrawerOpen(true);
	}
	const currentFolderContents: React.ReactNode = matrixId ? (
		<SpecificationFilesAndFoldersContents
			user={user}
			orgDetailsSelectedCategory={orgDetailsSelectedCategory}
			orgSpecifications={orgSpecifications}
			setOrgSpecifications={setOrgSpecifications}
			specDirectories={specDirectories}
			selectedMatrix={selectedMatrix}
			currentFolder={currentFolder}
			setCurrentFolder={setCurrentFolder}
			isInsideModal={false}
			setSpecDirectories={setSpecDirectories}
			setCreateSpecModalOpen={setCreateSpecModalOpen}
			openSpecReadingDrawer={openSpecReadingDrawer}
			selectedSpecificationId={undefined}
		/>
	) : (
		<></>
	);

	function updateSpecification(specification: FrontendSampleSpecification) {
		setOrgSpecifications((prevSpecs) => {
			// ADD 'return' here
			return prevSpecs.map((spec) => {
				if (spec.specificationId === specification.specificationId) {
					return specification;
				}
				return spec;
			});
		});
	}
	return (
		<>
			{currentFolderContents}

			{
				<>
					<CreateSpecificationAndReadingDrawer
						company={company}
						setCompany={setCompany}
						user={user}
						organizationId={props.organizationId}
						open={createSpecModalOpen}
						setOpen={setCreateSpecModalOpen}
						selectedMatrix={selectedMatrix as FrontendCompanySampleMatrix}
						currentFolderSpecifications={currentFolderSpecs}
						setFolderSpecifications={props.setOrgSpecifications}
						setSelectedSpecificationId={(id) => {}}
						testCategory={props.orgDetailsSelectedCategory}
						specDirectories={specDirectories}
						setSpecDirectories={setSpecDirectories}
					></CreateSpecificationAndReadingDrawer>
					<CreateOrUpdateSpecificationReadingDrawer
						company={company}
						setCompany={setCompany}
						user={user}
						open={editSpecReadingDrawerOpen}
						setOpen={setEditSpecReadingDrawerOpen}
						testCategory={props.orgDetailsSelectedCategory}
						selectedMatrix={selectedMatrix as FrontendCompanySampleMatrix}
						updateSpecification={updateSpecification}
						specDirectories={specDirectories}
						selectedSpecFile={selectedSpecFile as FrontendSampleSpecification}
					></CreateOrUpdateSpecificationReadingDrawer>
				</>
			}
		</>
	);
}
